export default __webpack_public_path__ + "static/media/industries.22522024.jpg";